import { CustomerRecipe } from "./CustomerRecipe";
import { ErpOrder } from "./ErpOrder";
import { OmniOrderSummary } from "./OmniOrderSummary";
import { Order } from "./Order";
import { OrderAlert } from "./OrderAlert";
import { OrderLocation } from "./OrderLocation";
import { Recipe } from "./Recipe";
import { StateLog } from "./StateLog";
import { StatePrescriptionLog } from "./StatePrescriptionLog";

export class OrderForListing {
  order: Order;
  stateLog?: StateLog;
  statePrescriptionLog?: StatePrescriptionLog;
  recipe: Recipe[] = [];
  customerRecipes: CustomerRecipe[] = [];
  erpOrders: ErpOrder[] = [];
  _selected: boolean = false;
  firstRecipeApprovedAt?: Date | null;
  currentStateName: string;
  currentStatePrescriptionName: string;
  influencerOrder: boolean = false;
  orderWithPrescriptionEyeGlassesForDifferentPersons: boolean = false;
  nonProgressivePrescriptionOrderWithMoreThanOneLens: boolean = false;
  daysSinceCreation: number;
  daysSincePayment?: number;
  daysSinceRecipeApproval?: number;
  daysSinceNpdApproval?: number;
  nonWorkingDaysSincePayment?: number;
  nonWorkingDaysSinceRecipeApproval?: number;
  nonWorkingDaysSinceNpdApproval?: number;
  allLensesArePlan: boolean;
  changeFromNonPrescriptionToPrescription?: boolean;
  changeFromPrescriptionToNonPrescription?: boolean;
  hasShippingLines: boolean;
  clientDelayDaysSinceBaseDateForDeliveryDeadline?: number;
  internalDelayDaysSinceBaseDateForDeliveryDeadline?: number;
  _alerts: OrderAlert[] = [];
  _informations: string[] = [];
  _workingDays?: number;
  _orderIsLate?: boolean;
  _externallyChanged?: boolean;
  _preSaleSport?: boolean;
  lensMaterialName: string;
  lensMaterialList?: string[];
  originLocationForCrossChannelSale?: OrderLocation;
  omniSummary?: OmniOrderSummary | null;
}